var BREAKPOINTS = {
    minimum: "320px",
    mobile: "640px",
    tablet: "768px",
    desktop: "925px",
    largeDesktop: "1800px"
};

var closeTo = function(breakpoint) {
    return breakpoint - 0.1;
};
var MEDIA_QUERIES = {
    fromMobile: "@media screen and (min-width: ".concat(BREAKPOINTS.mobile, "px)"),
    desktopMinimum: "@media screen and (min-width: ".concat(BREAKPOINTS.desktop, "px) and (max-width: ").concat(closeTo(+BREAKPOINTS.tablet), "px)"),
    fromDesktopMinimum: "@media screen and (min-width: ".concat(BREAKPOINTS.desktop, "px)"),
    tablet: "@media screen and (min-width: ".concat(BREAKPOINTS.tablet, "px) and (max-width: ").concat(closeTo(+BREAKPOINTS.desktop), "px)"),
    fromTablet: "@media screen and (min-width: ".concat(BREAKPOINTS.tablet, "px)"),
    desktopCompact: "@media screen and (min-width: ".concat(BREAKPOINTS.desktop, "px) and (max-width: ").concat(closeTo(+BREAKPOINTS.desktop), "px)"),
    fromDesktopCompact: "@media screen and (min-width: ".concat(BREAKPOINTS.desktop, "px)"),
    upToDesktopCompact: "@media screen and (max-width: ".concat(closeTo(+BREAKPOINTS.desktop), "px)"),
    fromDesktop: "@media screen and (min-width: ".concat(BREAKPOINTS.desktop, "px)")
};

function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}

var colorString$1 = {
    exports: {}
};

var colorName = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

var simpleSwizzle = {
    exports: {}
};

function _instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var isArrayish$1 = function isArrayish(obj) {
    if (!obj || typeof obj === "string") {
        return false;
    }
    return _instanceof$1(obj, Array) || Array.isArray(obj) || obj.length >= 0 && (_instanceof$1(obj.splice, Function) || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};

var isArrayish = isArrayish$1;
var concat = Array.prototype.concat;
var slice = Array.prototype.slice;
var swizzle$1 = simpleSwizzle.exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if (isArrayish(arg)) {
            // http://jsperf.com/javascript-array-concat-vs-push/98
            results = concat.call(results, slice.call(arg));
        } else {
            results.push(arg);
        }
    }
    return results;
};
swizzle$1.wrap = function(fn) {
    return function() {
        return fn(swizzle$1(arguments));
    };
};

var simpleSwizzleExports = simpleSwizzle.exports;

/* MIT license */

var colorNames = colorName;
var swizzle = simpleSwizzleExports;
var hasOwnProperty = Object.hasOwnProperty;
var reverseNames = Object.create(null);
// create a list of reverse color names
for(var name in colorNames){
    if (hasOwnProperty.call(colorNames, name)) {
        reverseNames[colorNames[name]] = name;
    }
}
var cs = colorString$1.exports = {
    to: {},
    get: {}
};
cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) {
        return null;
    }
    return {
        model: model,
        value: val
    };
};
cs.get.rgb = function(string) {
    if (!string) {
        return null;
    }
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) {
            rgb[3] = parseInt(hexAlpha, 16) / 255;
        }
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++){
            rgb[i] = parseInt(match[i] + match[i], 16);
        }
        if (hexAlpha) {
            rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
        }
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++){
            rgb[i] = parseInt(match[i + 1], 0);
        }
        if (match[4]) {
            if (match[5]) {
                rgb[3] = parseFloat(match[4]) * 0.01;
            } else {
                rgb[3] = parseFloat(match[4]);
            }
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++){
            rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        }
        if (match[4]) {
            if (match[5]) {
                rgb[3] = parseFloat(match[4]) * 0.01;
            } else {
                rgb[3] = parseFloat(match[4]);
            }
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") {
            return [
                0,
                0,
                0,
                0
            ];
        }
        if (!hasOwnProperty.call(colorNames, match[1])) {
            return null;
        }
        rgb = colorNames[match[1]];
        rgb[3] = 1;
        return rgb;
    } else {
        return null;
    }
    for(i = 0; i < 3; i++){
        rgb[i] = clamp(rgb[i], 0, 255);
    }
    rgb[3] = clamp(rgb[3], 0, 1);
    return rgb;
};
cs.get.hsl = function(string) {
    if (!string) {
        return null;
    }
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = clamp(parseFloat(match[2]), 0, 100);
        var l = clamp(parseFloat(match[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
cs.get.hwb = function(string) {
    if (!string) {
        return null;
    }
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = clamp(parseFloat(match[2]), 0, 100);
        var b = clamp(parseFloat(match[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
cs.to.hex = function() {
    var rgba = swizzle(arguments);
    return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : "");
};
cs.to.rgb = function() {
    var rgba = swizzle(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
cs.to.rgb.percent = function() {
    var rgba = swizzle(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
cs.to.hsl = function() {
    var hsla = swizzle(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function() {
    var hwba = swizzle(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) {
        a = ", " + hwba[3];
    }
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
cs.to.keyword = function(rgb) {
    return reverseNames[rgb.slice(0, 3)];
};
// helpers
function clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}

var colorStringExports = colorString$1.exports;

/* MIT license */

/* eslint-disable no-mixed-operators */ function _array_like_to_array$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$2(arr, i) {
    return _array_with_holes$2(arr) || _iterable_to_array_limit$2(arr, i) || _unsupported_iterable_to_array$2(arr, i) || _non_iterable_rest$2();
}
function _unsupported_iterable_to_array$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$2(o, minLen);
}
var cssKeywords = colorName;
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var reverseKeywords = {};
var _iteratorNormalCompletion$1 = true, _didIteratorError$1 = false, _iteratorError$1 = undefined;
try {
    for(var _iterator$1 = Object.keys(cssKeywords)[Symbol.iterator](), _step$1; !(_iteratorNormalCompletion$1 = (_step$1 = _iterator$1.next()).done); _iteratorNormalCompletion$1 = true){
        var key = _step$1.value;
        reverseKeywords[cssKeywords[key]] = key;
    }
} catch (err) {
    _didIteratorError$1 = true;
    _iteratorError$1 = err;
} finally{
    try {
        if (!_iteratorNormalCompletion$1 && _iterator$1.return != null) {
            _iterator$1.return();
        }
    } finally{
        if (_didIteratorError$1) {
            throw _iteratorError$1;
        }
    }
}
var convert$2 = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
var conversions$2 = convert$2;
var _iteratorNormalCompletion1$1 = true, _didIteratorError1$1 = false, _iteratorError1$1 = undefined;
try {
    // Hide .channels and .labels properties
    for(var _iterator1$1 = Object.keys(convert$2)[Symbol.iterator](), _step1$1; !(_iteratorNormalCompletion1$1 = (_step1$1 = _iterator1$1.next()).done); _iteratorNormalCompletion1$1 = true){
        var model$1 = _step1$1.value;
        if (!("channels" in convert$2[model$1])) {
            throw new Error("missing channels property: " + model$1);
        }
        if (!("labels" in convert$2[model$1])) {
            throw new Error("missing channel labels property: " + model$1);
        }
        if (convert$2[model$1].labels.length !== convert$2[model$1].channels) {
            throw new Error("channel and label counts mismatch: " + model$1);
        }
        var _convert_model = convert$2[model$1], channels = _convert_model.channels, labels = _convert_model.labels;
        delete convert$2[model$1].channels;
        delete convert$2[model$1].labels;
        Object.defineProperty(convert$2[model$1], "channels", {
            value: channels
        });
        Object.defineProperty(convert$2[model$1], "labels", {
            value: labels
        });
    }
} catch (err) {
    _didIteratorError1$1 = true;
    _iteratorError1$1 = err;
} finally{
    try {
        if (!_iteratorNormalCompletion1$1 && _iterator1$1.return != null) {
            _iterator1$1.return();
        }
    } finally{
        if (_didIteratorError1$1) {
            throw _iteratorError1$1;
        }
    }
}
convert$2.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    if (max === min) {
        h = 0;
    } else if (r === max) {
        h = (g - b) / delta;
    } else if (g === max) {
        h = 2 + (b - r) / delta;
    } else if (b === max) {
        h = 4 + (r - g) / delta;
    }
    h = Math.min(h * 60, 360);
    if (h < 0) {
        h += 360;
    }
    var l = (min + max) / 2;
    if (max === min) {
        s = 0;
    } else if (l <= 0.5) {
        s = delta / (max + min);
    } else {
        s = delta / (2 - max - min);
    }
    return [
        h,
        s * 100,
        l * 100
    ];
};
convert$2.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function diffc(c) {
        return (v - c) / 6 / diff + 1 / 2;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) {
            h = bdif - gdif;
        } else if (g === v) {
            h = 1 / 3 + rdif - bdif;
        } else if (b === v) {
            h = 2 / 3 + gdif - rdif;
        }
        if (h < 0) {
            h += 1;
        } else if (h > 1) {
            h -= 1;
        }
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
convert$2.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = convert$2.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
convert$2.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var k = Math.min(1 - r, 1 - g, 1 - b);
    var c = (1 - r - k) / (1 - k) || 0;
    var m = (1 - g - k) / (1 - k) || 0;
    var y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
convert$2.rgb.keyword = function(rgb) {
    var reversed = reverseKeywords[rgb];
    if (reversed) {
        return reversed;
    }
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(cssKeywords)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var keyword = _step.value;
            var value = cssKeywords[keyword];
            // Compute comparative distance
            var distance = comparativeDistance(rgb, value);
            // Check if its less, if so set as closest
            if (distance < currentClosestDistance) {
                currentClosestDistance = distance;
                currentClosestKeyword = keyword;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return currentClosestKeyword;
};
convert$2.keyword.rgb = function(keyword) {
    return cssKeywords[keyword];
};
convert$2.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
convert$2.rgb.lab = function(rgb) {
    var xyz = convert$2.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    var l = 116 * y - 16;
    var a = 500 * (x - y);
    var b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
convert$2.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t2;
    var t3;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) {
        t2 = l * (1 + s);
    } else {
        t2 = l + s - l * s;
    }
    var t1 = 2 * l - t2;
    var rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) {
            t3++;
        }
        if (t3 > 1) {
            t3--;
        }
        if (6 * t3 < 1) {
            val = t1 + (t2 - t1) * 6 * t3;
        } else if (2 * t3 < 1) {
            val = t2;
        } else if (3 * t3 < 2) {
            val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        } else {
            val = t1;
        }
        rgb[i] = val * 255;
    }
    return rgb;
};
convert$2.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    var v = (l + s) / 2;
    var sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
convert$2.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
convert$2.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var sl;
    var l;
    l = (2 - s) * v;
    var lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert$2.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    var i = Math.floor(6 * h);
    var v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) {
        f = 1 - f;
    }
    var n = wh + f * (v - wh); // Linear interpolation
    var r;
    var g;
    var b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert$2.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r = 1 - Math.min(1, c * (1 - k) + k);
    var g = 1 - Math.min(1, m * (1 - k) + k);
    var b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert$2.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.2040 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert$2.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    var l = 116 * y - 16;
    var a = 500 * (x - y);
    var b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
convert$2.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
convert$2.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var h;
    var hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) {
        h += 360;
    }
    var c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
convert$2.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var hr = h / 360 * 2 * Math.PI;
    var a = c * Math.cos(hr);
    var b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
convert$2.rgb.ansi16 = function(args) {
    var saturation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var _args = _sliced_to_array$2(args, 3), r = _args[0], g = _args[1], b = _args[2];
    var value = saturation === null ? convert$2.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) {
        return 30;
    }
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) {
        ansi += 60;
    }
    return ansi;
};
convert$2.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return convert$2.rgb.ansi16(convert$2.hsv.rgb(args), args[2]);
};
convert$2.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) {
            return 16;
        }
        if (r > 248) {
            return 231;
        }
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
convert$2.ansi16.rgb = function(args) {
    var color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) {
            color += 3.5;
        }
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
convert$2.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
convert$2.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
convert$2.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) {
        return [
            0,
            0,
            0
        ];
    }
    var colorString = match[0];
    if (match[0].length === 3) {
        colorString = colorString.split("").map(function(char) {
            return char + char;
        }).join("");
    }
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
convert$2.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) {
        grayscale = min / (1 - chroma);
    } else {
        grayscale = 0;
    }
    if (chroma <= 0) {
        hue = 0;
    } else if (max === r) {
        hue = (g - b) / chroma % 6;
    } else if (max === g) {
        hue = 2 + (b - r) / chroma;
    } else {
        hue = 4 + (r - g) / chroma;
    }
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
convert$2.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    var f = 0;
    if (c < 1.0) {
        f = (l - 0.5 * c) / (1.0 - c);
    }
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
convert$2.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) {
        f = (v - c) / (1 - c);
    }
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
convert$2.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) {
        return [
            g * 255,
            g * 255,
            g * 255
        ];
    }
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
convert$2.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) {
        f = c / v;
    }
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
convert$2.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) {
        s = c / (2 * l);
    } else if (l >= 0.5 && l < 1.0) {
        s = c / (2 * (1 - l));
    }
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
convert$2.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
convert$2.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) {
        g = (v - c) / (1 - c);
    }
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
convert$2.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
convert$2.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
convert$2.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
convert$2.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
convert$2.gray.hsv = convert$2.gray.hsl;
convert$2.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
convert$2.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
convert$2.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
convert$2.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
convert$2.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

var conversions$1 = conversions$2;
/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys(conversions$1);
    for(var len = models.length, i = 0; i < len; i++){
        graph[models[i]] = {
            // http://jsperf.com/1-vs-infinity
            // micro-opt, but this is simple.
            distance: -1,
            parent: null
        };
    }
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
    var graph = buildGraph();
    var queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys(conversions$1[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = conversions$1[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = link(conversions$1[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
var route$1 = function(fromModel) {
    var graph = deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) {
            continue;
        }
        conversion[toModel] = wrapConversion(toModel, graph);
    }
    return conversion;
};

var conversions = conversions$2;
var route = route$1;
var convert$1 = {};
var models = Object.keys(conversions);
function wrapRaw(fn) {
    var wrappedFn = function wrappedFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var arg0 = args[0];
        if (arg0 === undefined || arg0 === null) {
            return arg0;
        }
        if (arg0.length > 1) {
            args = arg0;
        }
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) {
        wrappedFn.conversion = fn.conversion;
    }
    return wrappedFn;
}
function wrapRounded(fn) {
    var wrappedFn = function wrappedFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var arg0 = args[0];
        if (arg0 === undefined || arg0 === null) {
            return arg0;
        }
        if (arg0.length > 1) {
            args = arg0;
        }
        var result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") {
            for(var len = result.length, i = 0; i < len; i++){
                result[i] = Math.round(result[i]);
            }
        }
        return result;
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) {
        wrappedFn.conversion = fn.conversion;
    }
    return wrappedFn;
}
models.forEach(function(fromModel) {
    convert$1[fromModel] = {};
    Object.defineProperty(convert$1[fromModel], "channels", {
        value: conversions[fromModel].channels
    });
    Object.defineProperty(convert$1[fromModel], "labels", {
        value: conversions[fromModel].labels
    });
    var routes = route(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        convert$1[fromModel][toModel] = wrapRounded(fn);
        convert$1[fromModel][toModel].raw = wrapRaw(fn);
    });
});
var colorConvert = convert$1;

function _array_like_to_array$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array$1(arr);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$1(arr, i) {
    return _array_with_holes$1(arr) || _iterable_to_array_limit$1(arr, i) || _unsupported_iterable_to_array$1(arr, i) || _non_iterable_rest$1();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array$1(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$1(o, minLen);
}
var colorString = colorStringExports;
var convert = colorConvert;
var skippedModels = [
    // To be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // Gray conflicts with some method names, and has its own method defined.
    "gray",
    // Shouldn't really be in color-convert either...
    "hex"
];
var hashedModelKeys = {};
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = Object.keys(convert)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var model = _step.value;
        hashedModelKeys[_to_consumable_array(convert[model].labels).sort().join("")] = model;
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var limiters = {};
function Color(object, model) {
    if (!_instanceof(this, Color)) {
        return new Color(object, model);
    }
    if (model && model in skippedModels) {
        model = null;
    }
    if (model && !(model in convert)) {
        throw new Error("Unknown model: " + model);
    }
    var i;
    var channels;
    if (object == null) {
        this.model = "rgb";
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (_instanceof(object, Color)) {
        this.model = object.model;
        this.color = _to_consumable_array(object.color);
        this.valpha = object.valpha;
    } else if (typeof object === "string") {
        var result = colorString.get(object);
        if (result === null) {
            throw new Error("Unable to parse color from string: " + object);
        }
        this.model = result.model;
        channels = convert[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
    } else if (object.length > 0) {
        this.model = model || "rgb";
        channels = convert[this.model].channels;
        var newArray = Array.prototype.slice.call(object, 0, channels);
        this.color = zeroArray(newArray, channels);
        this.valpha = typeof object[channels] === "number" ? object[channels] : 1;
    } else if (typeof object === "number") {
        // This is always RGB - can be converted later on.
        this.model = "rgb";
        this.color = [
            object >> 16 & 0xFF,
            object >> 8 & 0xFF,
            object & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        var keys = Object.keys(object);
        if ("alpha" in object) {
            keys.splice(keys.indexOf("alpha"), 1);
            this.valpha = typeof object.alpha === "number" ? object.alpha : 0;
        }
        var hashedKeys = keys.sort().join("");
        if (!(hashedKeys in hashedModelKeys)) {
            throw new Error("Unable to parse color from object: " + JSON.stringify(object));
        }
        this.model = hashedModelKeys[hashedKeys];
        var labels = convert[this.model].labels;
        var color = [];
        for(i = 0; i < labels.length; i++){
            color.push(object[labels[i]]);
        }
        this.color = zeroArray(color);
    }
    // Perform limitations (clamping, etc.)
    if (limiters[this.model]) {
        channels = convert[this.model].channels;
        for(i = 0; i < channels; i++){
            var limit = limiters[this.model][i];
            if (limit) {
                this.color[i] = limit(this.color[i]);
            }
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) {
        Object.freeze(this);
    }
}
Color.prototype = {
    toString: function toString() {
        return this.string();
    },
    toJSON: function toJSON() {
        return this[this.model]();
    },
    string: function string(places) {
        var self = this.model in colorString.to ? this : this.rgb();
        self = self.round(typeof places === "number" ? places : 1);
        var args = self.valpha === 1 ? self.color : _to_consumable_array(self.color).concat([
            this.valpha
        ]);
        return colorString.to[self.model](args);
    },
    percentString: function percentString(places) {
        var self = this.rgb().round(typeof places === "number" ? places : 1);
        var args = self.valpha === 1 ? self.color : _to_consumable_array(self.color).concat([
            this.valpha
        ]);
        return colorString.to.rgb.percent(args);
    },
    array: function array() {
        return this.valpha === 1 ? _to_consumable_array(this.color) : _to_consumable_array(this.color).concat([
            this.valpha
        ]);
    },
    object: function object() {
        var result = {};
        var channels = convert[this.model].channels;
        var labels = convert[this.model].labels;
        for(var i = 0; i < channels; i++){
            result[labels[i]] = this.color[i];
        }
        if (this.valpha !== 1) {
            result.alpha = this.valpha;
        }
        return result;
    },
    unitArray: function unitArray() {
        var rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) {
            rgb.push(this.valpha);
        }
        return rgb;
    },
    unitObject: function unitObject() {
        var rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) {
            rgb.alpha = this.valpha;
        }
        return rgb;
    },
    round: function round(places) {
        places = Math.max(places || 0, 0);
        return new Color(_to_consumable_array(this.color.map(roundToPlace(places))).concat([
            this.valpha
        ]), this.model);
    },
    alpha: function alpha(value) {
        if (value !== undefined) {
            return new Color(_to_consumable_array(this.color).concat([
                Math.max(0, Math.min(1, value))
            ]), this.model);
        }
        return this.valpha;
    },
    // Rgb
    red: getset("rgb", 0, maxfn(255)),
    green: getset("rgb", 1, maxfn(255)),
    blue: getset("rgb", 2, maxfn(255)),
    hue: getset([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, function(value) {
        return (value % 360 + 360) % 360;
    }),
    saturationl: getset("hsl", 1, maxfn(100)),
    lightness: getset("hsl", 2, maxfn(100)),
    saturationv: getset("hsv", 1, maxfn(100)),
    value: getset("hsv", 2, maxfn(100)),
    chroma: getset("hcg", 1, maxfn(100)),
    gray: getset("hcg", 2, maxfn(100)),
    white: getset("hwb", 1, maxfn(100)),
    wblack: getset("hwb", 2, maxfn(100)),
    cyan: getset("cmyk", 0, maxfn(100)),
    magenta: getset("cmyk", 1, maxfn(100)),
    yellow: getset("cmyk", 2, maxfn(100)),
    black: getset("cmyk", 3, maxfn(100)),
    x: getset("xyz", 0, maxfn(95.047)),
    y: getset("xyz", 1, maxfn(100)),
    z: getset("xyz", 2, maxfn(108.833)),
    l: getset("lab", 0, maxfn(100)),
    a: getset("lab", 1),
    b: getset("lab", 2),
    keyword: function keyword(value) {
        if (value !== undefined) {
            return new Color(value);
        }
        return convert[this.model].keyword(this.color);
    },
    hex: function hex(value) {
        if (value !== undefined) {
            return new Color(value);
        }
        return colorString.to.hex(this.rgb().round().color);
    },
    hexa: function hexa(value) {
        if (value !== undefined) {
            return new Color(value);
        }
        var rgbArray = this.rgb().round().color;
        var alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
        if (alphaHex.length === 1) {
            alphaHex = "0" + alphaHex;
        }
        return colorString.to.hex(rgbArray) + alphaHex;
    },
    rgbNumber: function rgbNumber() {
        var rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity: function luminosity() {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        var rgb = this.rgb().color;
        var lum = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rgb.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array$1(_step.value, 2), i = _step_value[0], element = _step_value[1];
                var chan = element / 255;
                lum[i] = chan <= 0.04045 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function contrast(color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) {
            return (lum1 + 0.05) / (lum2 + 0.05);
        }
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function level(color2) {
        // https://www.w3.org/TR/WCAG/#contrast-enhanced
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7) {
            return "AAA";
        }
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    isDark: function isDark() {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        var rgb = this.rgb().color;
        var yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 10000;
        return yiq < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    negate: function negate() {
        var rgb = this.rgb();
        for(var i = 0; i < 3; i++){
            rgb.color[i] = 255 - rgb.color[i];
        }
        return rgb;
    },
    lighten: function lighten(ratio) {
        var hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken: function darken(ratio) {
        var hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate: function saturate(ratio) {
        var hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate: function desaturate(ratio) {
        var hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten: function whiten(ratio) {
        var hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken: function blacken(ratio) {
        var hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale: function grayscale() {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        var rgb = this.rgb().color;
        var value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return Color.rgb(value, value, value);
    },
    fade: function fade(ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer: function opaquer(ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate: function rotate(degrees) {
        var hsl = this.hsl();
        var hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix: function mix(mixinColor, weight) {
        // Ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) {
            throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + (typeof mixinColor === "undefined" ? "undefined" : _type_of(mixinColor)));
        }
        var color1 = mixinColor.rgb();
        var color2 = this.rgb();
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        var w2 = 1 - w1;
        return Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
try {
    var _loop = function() {
        var model = _step1.value;
        if (skippedModels.includes(model)) {
            return "continue";
        }
        var channels = convert[model].channels;
        // Conversion methods
        Color.prototype[model] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this.model === model) {
                return new Color(this);
            }
            if (args.length > 0) {
                return new Color(args, model);
            }
            return new Color(_to_consumable_array(assertArray(convert[this.model][model].raw(this.color))).concat([
                this.valpha
            ]), model);
        };
        // 'static' construction methods
        Color[model] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var color = args[0];
            if (typeof color === "number") {
                color = zeroArray(args, channels);
            }
            return new Color(color, model);
        };
    };
    // Model conversion methods and static constructors
    for(var _iterator1 = Object.keys(convert)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
} catch (err) {
    _didIteratorError1 = true;
    _iteratorError1 = err;
} finally{
    try {
        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
            _iterator1.return();
        }
    } finally{
        if (_didIteratorError1) {
            throw _iteratorError1;
        }
    }
}
function roundTo(number, places) {
    return Number(number.toFixed(places));
}
function roundToPlace(places) {
    return function(number) {
        return roundTo(number, places);
    };
}
function getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = model[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var m = _step.value;
            (limiters[m] || (limiters[m] = []))[channel] = modifier;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    model = model[0];
    return function(value) {
        var result;
        if (value !== undefined) {
            if (modifier) {
                value = modifier(value);
            }
            result = this[model]();
            result.color[channel] = value;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) {
            result = modifier(result);
        }
        return result;
    };
}
function maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function assertArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function zeroArray(array, length) {
    for(var i = 0; i < length; i++){
        if (typeof array[i] !== "number") {
            array[i] = 0;
        }
    }
    return array;
}
var color = Color;

var Color$1 = /*@__PURE__*/getDefaultExportFromCjs(color);

var borderStyles = {
    none: "none",
    solid: "solid"
};
var borderWidths = {
    none: "0px",
    sm: "1px",
    md: "2px"
};

var breakpoints = {
    mobile: 320,
    desktopMinimum: 480,
    tablet: 1024,
    desktopCompact: 1140,
    desktop: 1280
};
var mediaQueries = {
    from: function(bp) {
        return "@media screen and (width >= ".concat(breakpoints[bp], "px)");
    },
    upTo: function(bp) {
        return "@media screen and (width < ".concat(breakpoints[bp], "px)");
    },
    between: function(bp1, bp2) {
        return "@media screen and (width >= ".concat(breakpoints[bp1], "px) and (width < ").concat(breakpoints[bp2], "px)");
    }
};

function _define_property$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$4(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$3(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var baseColors = {
    transparent: "transparent",
    inherit: "inherit",
    brand: {
        navy: "#150E3F",
        deepLavendar: "#7E4BBC",
        orange: "#F15852"
    },
    neutrals: {
        900: "#1F1F23",
        800: "#484851",
        700: "#6C6C7A",
        750: "#5B5B67",
        600: "#A0A0AB",
        500: "#BCBCC3",
        400: "#DBDBE0",
        300: "#E7E7E9",
        200: "#F1F1F3",
        100: "#F6F6F7",
        0: "#FFFFFF"
    },
    indigos: {
        900: "#2222C3",
        800: "#391EE6",
        500: "#492FF4",
        200: "#D7D7FE",
        100: "#EBEBFE"
    },
    greens: {
        900: "#064C1D",
        800: "#095D25",
        500: "#06742B",
        200: "#B1F6BD",
        100: "#D1FFD9"
    },
    yellows: {
        800: "#704D00",
        500: "#FFBF00",
        200: "#FFE38D",
        100: "#FFF1C7"
    },
    reds: {
        900: "#860329",
        800: "#9E002D",
        500: "#BF0338",
        400: "#E70545",
        200: "#FFCCD2",
        100: "#FFE6E9"
    }
};
var colors = _object_spread_props$3(_object_spread$4({}, baseColors), {
    text: {
        inherit: baseColors.inherit,
        onDark: baseColors.neutrals[0],
        default: baseColors.neutrals[900],
        secondary: baseColors.neutrals[700],
        secondaryOnGray: baseColors.neutrals[750],
        primary: baseColors.indigos[500],
        primaryOnDark: baseColors.indigos[100],
        error: baseColors.reds[500],
        errorOnDark: baseColors.reds[100],
        warning: baseColors.yellows[800],
        success: baseColors.greens[500],
        activationOnDark: baseColors.greens[100]
    },
    textLoading: {
        inherit: baseColors.inherit,
        onDark: baseColors.neutrals[0],
        default: baseColors.neutrals[100],
        secondary: baseColors.neutrals[100],
        secondaryOnGray: baseColors.neutrals[500],
        primary: baseColors.indigos[100],
        primaryOnDark: baseColors.indigos[100],
        error: baseColors.neutrals[100],
        errorOnDark: baseColors.neutrals[100],
        warning: baseColors.neutrals[100],
        success: baseColors.neutrals[100],
        activationOnDark: baseColors.greens[100]
    },
    forms: {
        label: baseColors.neutrals[900],
        placeholder: baseColors.neutrals[700],
        placeholderActive: baseColors.neutrals[600],
        placeholderOnGray: baseColors.neutrals[750]
    },
    borders: {
        none: baseColors.transparent,
        default: baseColors.neutrals[400],
        form: baseColors.neutrals[700],
        primary: baseColors.indigos[500],
        primaryActive: baseColors.indigos[900],
        error: baseColors.reds[500],
        errorActive: baseColors.reds[900],
        activationActive: baseColors.greens[900]
    },
    outlines: {
        input: baseColors.indigos[500],
        default: baseColors.brand.deepLavendar
    },
    shadows: {
        white: baseColors.neutrals[0],
        default: baseColors.neutrals[400],
        secondary: baseColors.neutrals[900],
        primary: baseColors.indigos[500],
        success: baseColors.greens[800],
        warning: baseColors.yellows[800],
        error: baseColors.reds[900],
        primaryDestructive: baseColors.reds[500],
        activation: baseColors.greens[500]
    },
    controls: {
        inherit: baseColors.inherit,
        default: baseColors.neutrals[900],
        primary: baseColors.indigos[500],
        primaryHover: baseColors.indigos[800],
        primaryActive: baseColors.indigos[900],
        secondary: baseColors.neutrals[200],
        secondaryOnGray: baseColors.neutrals[300],
        secondaryHover: baseColors.neutrals[400],
        secondaryActive: baseColors.neutrals[500],
        secondaryAccent: baseColors.indigos[100],
        subtle: baseColors.transparent,
        subtleHover: baseColors.neutrals[400],
        subtleActive: baseColors.neutrals[500],
        destructive: baseColors.reds[500],
        destructiveHover: baseColors.reds[800],
        destructiveActive: baseColors.reds[900],
        secondaryDestructive: baseColors.reds[100],
        subtleDestructive: baseColors.transparent,
        subtleDestructiveHover: baseColors.reds[500],
        subtleDestructiveActive: baseColors.reds[800],
        white: baseColors.neutrals[0],
        activation: baseColors.greens[500],
        activationHover: baseColors.greens[800],
        activationActive: baseColors.greens[900],
        notification: baseColors.reds[400]
    },
    skeletons: {
        primary: baseColors.indigos[100],
        destructive: baseColors.reds[100],
        secondary: baseColors.neutrals[500],
        secondaryActive: baseColors.neutrals[500],
        secondaryAccent: baseColors.neutrals[500],
        secondaryDestructive: baseColors.reds[200],
        secondaryOnGray: baseColors.neutrals[500],
        subtle: baseColors.neutrals[500],
        subtleDestructive: baseColors.reds[100],
        activation: baseColors.greens[100]
    },
    backgrounds: {
        none: baseColors.transparent,
        onGray: baseColors.neutrals[0],
        default: baseColors.neutrals[100],
        secondary: baseColors.neutrals[200],
        secondaryOnGray: baseColors.neutrals[300],
        accent: baseColors.indigos[100],
        success: baseColors.greens[100],
        warning: baseColors.yellows[100],
        error: baseColors.reds[100],
        dark: baseColors.neutrals[900]
    }
});

var debounceTime = {
    none: 0,
    snappy: 30,
    standard: 300,
    delayed: 600
};

var throttleTime = {
    standard: 1000
};

var opacity = {
    default: "1",
    disabled: "0.64",
    underlay: "0.48",
    faded: "0.64"
};

var radii = {
    x0: "0px",
    x_5: "2px",
    x1: "4px",
    x1_5: "6px",
    x2: "8px",
    x3: "12px",
    x3_5: "14px",
    x4: "16px"
};

var outlines = {
    none: "none",
    common: {
        borderRadius: radii.x1_5
    },
    item: {
        rule: "".concat(borderWidths.md, " ").concat(borderStyles.solid, " ").concat(colors.outlines.default),
        offset: "-2px"
    },
    control: {
        rule: "".concat(borderWidths.md, " ").concat(borderStyles.solid, " ").concat(colors.outlines.default),
        offset: "2px"
    },
    input: {
        rule: "".concat(borderWidths.sm, " ").concat(borderStyles.solid, " ").concat(colors.outlines.input),
        offset: "-1px"
    },
    link: {
        rule: "".concat(borderWidths.md, " ").concat(borderStyles.solid, " ").concat(colors.outlines.default),
        offset: "2px",
        borderRadius: radii.x_5
    },
    tab: {
        rule: "".concat(borderWidths.md, " ").concat(borderStyles.solid, " ").concat(colors.outlines.default),
        offset: "-2px"
    }
};

var shadows = {
    styles: {
        none: "none",
        inset: "0px -1px 0px 0px inset",
        rightInnerBorder: "-1px 0px 0px inset",
        leftInnerBorder: "1px 0px 0px 0px inset",
        broad: "0px 8px 16px",
        narrow: "0px 2px 6px",
        border: "0px 0px 1px",
        borderBottom: "0px 1px 0px",
        medium: "0px 4px 12px"
    },
    alphas: {
        full: "1",
        x0: "0",
        x1: "0.04",
        x2: "0.08",
        x3: "0.12",
        x4: "0.16",
        x5: "0.20",
        x6: "0.24",
        x8: "0.32"
    }
};

var sizes$1 = {
    x2: "8px",
    x3: "12px",
    x4: "16px",
    x5: "20px",
    x6: "24px",
    x7: "28px",
    x8: "32px",
    x9: "36px",
    x10: "40px",
    x11: "44px",
    x12: "48px",
    x13: "52px",
    x14: "56px",
    x16: "64px",
    x24: "96px",
    x30: "120px",
    x50: "200px",
    x56: "224px",
    x59: "236px",
    x60: "240px",
    x74: "296px",
    x80: "320px",
    x100: "400px",
    x120: "480px"
};

var space = {
    x0: "0px",
    x_5: "2px",
    x1: "4px",
    x1_5: "6px",
    x2: "8px",
    x3: "12px",
    x4: "16px",
    x6: "24px",
    x7: "28px",
    x10: "40px",
    x18: "72px"
};

var buttonBase = {
    paddingY: space.x1,
    paddingX: space.x3
};
var buttonVariants = {
    primary: {
        inactive: {
            backgroundColor: "primary",
            textColor: "primaryOnDark",
            skeletonColor: "primary",
            boxShadow: {
                alpha: "x5",
                style: "medium",
                color: "primary"
            }
        },
        hovered: {
            backgroundColor: "primaryHover",
            textColor: "primaryOnDark",
            boxShadow: {
                alpha: "x5",
                style: "medium",
                color: "primary"
            }
        },
        active: {
            backgroundColor: "primaryActive"
        },
        pressed: {
            backgroundColor: "primary",
            border: "primaryActive"
        },
        focused: {
            backgroundColor: "primaryHover",
            textColor: "primaryOnDark"
        }
    },
    secondary: {
        inactive: {
            backgroundColor: "secondary",
            textColor: "default",
            skeletonColor: "secondary"
        },
        hovered: {
            backgroundColor: "secondaryHover"
        },
        active: {
            backgroundColor: "secondaryActive"
        },
        pressed: {
            border: "primary"
        },
        focused: {
            backgroundColor: "secondaryHover"
        }
    },
    secondaryAccent: {
        inactive: {
            backgroundColor: "secondaryAccent",
            textColor: "primary",
            skeletonColor: "secondaryAccent"
        },
        hovered: {
            backgroundColor: "primaryHover",
            textColor: "primaryOnDark"
        },
        active: {
            backgroundColor: "primaryActive",
            textColor: "primaryOnDark"
        },
        pressed: {
            border: "primary"
        },
        focused: {
            backgroundColor: "primaryHover",
            textColor: "primaryOnDark"
        }
    },
    subtle: {
        inactive: {
            backgroundColor: "subtle",
            textColor: "default",
            skeletonColor: "subtle"
        },
        hovered: {
            backgroundColor: "subtleHover"
        },
        active: {
            backgroundColor: "subtleActive"
        },
        pressed: {
            backgroundColor: "secondary",
            border: "primary"
        },
        focused: {
            backgroundColor: "subtleHover"
        }
    },
    secondaryOnGray: {
        inactive: {
            backgroundColor: "secondaryOnGray",
            textColor: "default",
            skeletonColor: "secondaryOnGray"
        },
        hovered: {
            backgroundColor: "secondaryHover"
        },
        active: {
            backgroundColor: "secondaryActive"
        },
        pressed: {
            border: "primary"
        },
        focused: {
            backgroundColor: "secondaryHover"
        }
    },
    primaryDestructive: {
        inactive: {
            backgroundColor: "destructive",
            textColor: "errorOnDark",
            skeletonColor: "destructive",
            boxShadow: {
                alpha: "x5",
                style: "medium",
                color: "primaryDestructive"
            }
        },
        hovered: {
            backgroundColor: "destructiveHover",
            boxShadow: {
                alpha: "x5",
                style: "medium",
                color: "primaryDestructive"
            }
        },
        active: {
            backgroundColor: "destructiveActive"
        },
        pressed: {
            border: "errorActive"
        },
        focused: {
            backgroundColor: "destructiveHover"
        }
    },
    secondaryDestructive: {
        inactive: {
            backgroundColor: "secondaryDestructive",
            textColor: "error",
            skeletonColor: "secondaryDestructive"
        },
        hovered: {
            backgroundColor: "destructiveHover",
            textColor: "errorOnDark"
        },
        active: {
            backgroundColor: "destructiveActive",
            textColor: "errorOnDark"
        },
        pressed: {
            border: "primary"
        },
        focused: {
            backgroundColor: "destructiveHover",
            textColor: "errorOnDark"
        }
    },
    subtleDestructive: {
        inactive: {
            backgroundColor: "subtleDestructive",
            textColor: "error",
            skeletonColor: "subtleDestructive"
        },
        hovered: {
            backgroundColor: "subtleDestructiveHover",
            textColor: "errorOnDark"
        },
        active: {
            backgroundColor: "subtleDestructiveActive",
            textColor: "errorOnDark"
        },
        pressed: {
            backgroundColor: "secondaryDestructive",
            border: "primary"
        },
        focused: {
            backgroundColor: "subtleDestructiveHover",
            textColor: "errorOnDark"
        }
    },
    activation: {
        inactive: {
            backgroundColor: "activation",
            textColor: "activationOnDark",
            skeletonColor: "activation",
            boxShadow: {
                alpha: "x5",
                style: "medium",
                color: "activation"
            }
        },
        hovered: {
            backgroundColor: "activationHover",
            textColor: "activationOnDark",
            boxShadow: {
                alpha: "x5",
                style: "medium",
                color: "activation"
            }
        },
        active: {
            backgroundColor: "activationActive",
            textColor: "activationOnDark"
        },
        pressed: {
            border: "activationActive"
        },
        focused: {
            backgroundColor: "activationHover",
            textColor: "activationOnDark"
        }
    },
    plain: {
        inactive: {
            backgroundColor: "inherit",
            textColor: "inherit",
            skeletonColor: "subtle"
        },
        hovered: {},
        active: {},
        pressed: {},
        focused: {}
    }
};

var headings = {
    "1": {
        fontSize: "xl",
        lineHeight: "xl",
        fontWeight: "headingMain",
        textDecoration: "none",
        letterSpacing: "normal",
        color: "default"
    },
    "2": {
        fontSize: "l",
        lineHeight: "l",
        fontWeight: "heading",
        textDecoration: "none",
        letterSpacing: "normal",
        color: "default"
    },
    "3": {
        fontSize: "m",
        lineHeight: "m",
        fontWeight: "heading",
        textDecoration: "none",
        letterSpacing: "normal",
        color: "default"
    },
    "4": {
        fontSize: "s",
        lineHeight: "m",
        fontWeight: "heading",
        textDecoration: "none",
        letterSpacing: "normal",
        color: "default"
    },
    "5": {
        fontSize: "xs",
        lineHeight: "s",
        fontWeight: "heading",
        textDecoration: "uppercase",
        letterSpacing: "wide",
        color: "secondary"
    }
};

var fontStack = '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;';
var fonts = {
    heading: fontStack,
    body: fontStack
};
var fontSizes = {
    xs: "12px",
    s: "14px",
    m: "16px",
    l: "20px",
    xl: "24px"
};
var fontWeights = {
    standard: "400",
    emphasised: "600",
    heading: "700",
    headingMain: "800"
};
var lineHeights = {
    none: "0",
    default: "1",
    xs: "18px",
    s: "20px",
    m: "24px",
    l: "32px",
    xl: "36px"
};
var letterSpacings = {
    normal: "0",
    wide: "0.25px"
};
var textDecorationThicknesses = {
    s: "1px",
    m: "2px",
    l: "3px"
};
var textDecorationLines = {
    underline: "underline",
    none: "none"
};

var paragraphs = {
    default: {
        fontSize: "s",
        lineHeight: "s",
        fontWeight: "standard",
        textDecoration: "none",
        letterSpacing: "normal"
    },
    emphasised: {
        fontSize: "s",
        lineHeight: "s",
        fontWeight: "emphasised",
        textDecoration: "none",
        letterSpacing: "normal"
    },
    compact: {
        fontSize: "s",
        lineHeight: "xs",
        fontWeight: "standard",
        textDecoration: "none",
        letterSpacing: "normal"
    },
    compactEmphasised: {
        fontSize: "s",
        lineHeight: "xs",
        fontWeight: "emphasised",
        textDecoration: "none",
        letterSpacing: "normal"
    },
    small: {
        fontSize: "xs",
        lineHeight: "s",
        fontWeight: "standard",
        textDecoration: "none",
        letterSpacing: "normal"
    },
    smallEmphasised: {
        fontSize: "xs",
        lineHeight: "s",
        fontWeight: "emphasised",
        textDecoration: "none",
        letterSpacing: "normal"
    },
    smallCompact: {
        fontSize: "xs",
        lineHeight: "xs",
        fontWeight: "standard",
        textDecoration: "none",
        letterSpacing: "normal"
    },
    smallCompactEmphasised: {
        fontSize: "xs",
        lineHeight: "xs",
        fontWeight: "emphasised",
        textDecoration: "none",
        letterSpacing: "normal"
    }
};

function _define_property$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$3(target, key, source[key]);
        });
    }
    return target;
}
var baseLink = {
    cursor: "pointer",
    background: "none",
    borderStyle: borderStyles.none,
    padding: space.x0,
    color: "primary",
    textDecorationLine: "none",
    textDecorationThickness: textDecorationThicknesses.s
};
var linkVariants = _object_spread$3({}, paragraphs);
var linkSettings = {
    standalone: {
        textDecorationThickness: "s",
        fontWeight: "standard",
        color: "primary",
        textDecorationLine: "none",
        ":hover": {
            color: colors.controls.primaryHover,
            textDecorationLine: textDecorationLines.underline
        },
        ":active": {
            color: colors.controls.primaryActive
        },
        ":visited": {
            color: colors.brand.deepLavendar
        }
    },
    inline: {
        textDecorationThickness: "s",
        fontWeight: "standard",
        fontSize: "inherit",
        color: "inherit",
        textDecorationLine: "underline",
        ":hover": {
            opacity: opacity.faded,
            color: colors.inherit
        },
        ":active": {
            color: colors.inherit
        },
        ":visited": {
            color: colors.inherit
        }
    }
};

var baseInput = {
    minHeight: sizes$1.x8,
    borderWidth: borderWidths.sm,
    borderStyle: borderStyles.solid,
    borderRadius: radii.x1_5
};
var inputStates = {
    inactive: {
        color: colors.text.default,
        backgroundColor: colors.controls.secondary,
        borderColor: colors.transparent,
        placeholder: colors.forms.placeholder,
        placeholderActive: colors.forms.placeholderActive,
        placeholderOnGray: colors.forms.placeholderOnGray,
        iconColor: colors.forms.placeholder,
        actionColor: colors.text.default
    },
    hover: {
        color: colors.text.default,
        backgroundColor: colors.controls.secondaryHover,
        borderColor: colors.transparent,
        placeholder: colors.forms.placeholder,
        placeholderActive: colors.forms.placeholderActive,
        placeholderOnGray: colors.forms.placeholderOnGray,
        iconColor: colors.forms.placeholder,
        actionColor: colors.text.secondary
    },
    active: {
        color: colors.text.default,
        backgroundColor: colors.controls.white,
        borderColor: colors.borders.primary,
        placeholder: colors.forms.placeholder,
        placeholderActive: colors.forms.placeholderActive,
        placeholderOnGray: colors.forms.placeholderOnGray,
        iconColor: colors.forms.placeholder,
        actionColor: colors.text.default
    },
    error: {
        color: colors.text.default,
        backgroundColor: colors.controls.secondary,
        borderColor: colors.borders.error,
        placeholder: colors.forms.placeholder,
        placeholderActive: colors.forms.placeholderActive,
        placeholderOnGray: colors.forms.placeholderOnGray,
        iconColor: colors.forms.placeholder,
        actionColor: colors.text.default
    },
    disabled: {
        color: colors.text.default,
        backgroundColor: colors.controls.secondary,
        borderColor: colors.transparent,
        placeholder: colors.forms.placeholder,
        placeholderActive: colors.forms.placeholderActive,
        placeholderOnGray: colors.forms.placeholderOnGray,
        iconColor: colors.forms.placeholder,
        actionColor: colors.text.default,
        opacity: opacity.disabled
    }
};

function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var basePill = {
    borderRadius: radii.x3,
    paddingLeft: space.x2,
    paddingRight: space.x2
};
var pillTypography = _object_spread_props$2(_object_spread$2({}, paragraphs.smallCompact), {
    lineHeight: "s"
});
var pillVariants = {
    neutral: {
        backgroundColor: colors.backgrounds.secondaryOnGray,
        color: colors.text.default
    },
    warning: {
        backgroundColor: colors.backgrounds.warning,
        color: colors.text.warning
    },
    error: {
        backgroundColor: colors.backgrounds.error,
        color: colors.text.error
    },
    accent: {
        backgroundColor: colors.backgrounds.accent,
        color: colors.text.primary
    },
    success: {
        backgroundColor: colors.backgrounds.success,
        color: colors.text.success
    }
};

var header = {
    background: "default",
    boxShadow: {
        style: "none"
    },
    color: "secondary",
    height: sizes$1.x9,
    paddingTop: "x0",
    paddingBottom: "x0",
    paddingLeft: "x4",
    paddingRight: "x4",
    textAlign: "left",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};
var cell = {
    background: "onGray",
    boxShadow: {
        alpha: "full",
        style: "inset",
        color: "default"
    },
    color: "default",
    height: sizes$1.x12,
    paddingTop: "x0",
    paddingBottom: "x0",
    paddingLeft: "x4",
    paddingRight: "x4",
    textAlign: "left",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};
var subRow = {
    background: "default"
};
var row = {
    background: "onGray"
};
var cellSizes = {
    standard: {
        height: sizes$1.x12
    },
    compact: {
        height: sizes$1.x9
    },
    relaxed: {
        height: sizes$1.x14
    }
};
var cellVariants = {
    text: {},
    numeric: {
        textAlign: "right"
    },
    link: {},
    emphasisedLink: {},
    actions: {},
    custom: {},
    expansion: {}
};
var rowStates = {
    hover: {
        background: "default",
        boxShadow: {
            style: "none"
        }
    },
    selected: {
        background: "accent",
        boxShadow: {
            style: "none"
        }
    }
};
var subRowStates = {
    hover: {
        background: "secondaryOnGray",
        boxShadow: {
            style: "none"
        }
    }
};

var uiText = {
    control: {
        fontSize: "s",
        lineHeight: "m",
        fontWeight: "emphasised",
        textDecoration: "none",
        letterSpacing: "normal"
    },
    label: {
        fontSize: "xs",
        lineHeight: "s",
        fontWeight: "emphasised",
        textDecoration: "none",
        letterSpacing: "normal"
    },
    input: {
        fontSize: "s",
        lineHeight: "m",
        fontWeight: "standard",
        textDecoration: "none",
        letterSpacing: "normal"
    },
    placeholder: {
        fontSize: "s",
        lineHeight: "m",
        fontWeight: "standard",
        textDecoration: "none",
        letterSpacing: "normal"
    }
};
var uiInterspersedText = {
    margin: "".concat(space.x0, " ").concat(space.x2)
};

var notificationStatuses = {
    error: {
        backgroundColor: "error",
        borderColor: "error",
        color: "error",
        shadowColor: "error",
        icon: "warning"
    },
    info: {
        backgroundColor: "secondary",
        borderColor: "secondary",
        color: "default",
        shadowColor: "secondary",
        icon: "info"
    },
    success: {
        backgroundColor: "success",
        borderColor: "success",
        color: "success",
        shadowColor: "success",
        icon: "success"
    },
    warning: {
        backgroundColor: "warning",
        borderColor: "warning",
        color: "warning",
        shadowColor: "warning",
        icon: "warning"
    },
    accent: {
        backgroundColor: "accent",
        borderColor: "primary",
        color: "primary",
        shadowColor: "primary",
        icon: "accent"
    }
};
var notificationVariants = {
    banner: {
        borderStyle: "none",
        borderWidth: "none",
        borderRadius: "x1_5",
        padding: "x3",
        width: "100%"
    },
    sectionBanner: {
        borderStyle: "none",
        borderWidth: "none",
        borderRadius: "x0",
        padding: "x3",
        width: "100%"
    },
    toast: {
        borderStyle: "solid",
        borderWidth: "sm",
        borderRadius: "x1_5",
        padding: "x3",
        width: "fit-content"
    }
};

var container$1 = {
    top: "25%",
    paddingLeft: space.x6,
    paddingRight: space.x6
};

var contentContainer = {
    marginBottom: space.x2
};
var legend = {
    marginBottom: space.x3
};

var iconSizes = {
    small: sizes$1.x3,
    standard: sizes$1.x4,
    large: sizes$1.x6,
    illustrative: sizes$1.x16
};
var beameryIconSize = {
    width: "118px",
    height: "32px"
};
var strokeWidths = {
    default: "1.5",
    illustrative: "4px"
};

var checkboxBase = {
    cursor: "pointer"
};
var checkboxIcon = {
    borderWidth: borderWidths.sm,
    borderRadius: radii.x1
};
var checkboxIconStates = {
    inactive: {
        borderColor: "form",
        backgroundColor: "white"
    },
    hover: {
        borderColor: "primary",
        backgroundColor: "white"
    },
    active: {
        borderColor: "primaryActive",
        backgroundColor: "primaryActive"
    }
};

var listBoxBase = {
    borderRadius: radii.x1_5,
    backgroundColor: colors.backgrounds.onGray,
    boxShadow: {
        alpha: "x3",
        style: "broad",
        color: "secondary"
    }
};
var listBoxSectionLabel = {
    paddingX: space.x3,
    paddingY: space.x2
};
var listBoxEmptyState = {
    marginX: space.x3,
    marginY: space.x10
};
var listBoxSection = {
    withCheckbox: {
        paddingLeft: space.x3
    },
    withoutCheckbox: {
        paddingLeft: space.x6
    }
};
var listBoxItemBase = {
    cursor: "pointer",
    height: sizes$1.x9
};
var listBoxItemStates = {
    inactive: {
        color: "default",
        backgroundColor: "onGray"
    },
    hovered: {
        color: "default",
        backgroundColor: "default"
    },
    active: {
        color: "primaryActive",
        backgroundColor: "onGray"
    }
};

var listBase = {
    spaceBetween: space.x4
};
var listItemWithSeperator = {
    paddingBottom: space.x3,
    boxShadow: {
        style: "inset",
        color: "default",
        alpha: "full"
    }
};

var menuBox = {
    variant: {
        neutral: {
            color: colors.text.default
        },
        destructive: {
            color: colors.text.error
        }
    }
};

var transitions = {
    property: {
        common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
        colors: "background-color, border-color, color, fill, stroke",
        dimensions: "width, height",
        position: "left, right, top, bottom",
        background: "background-color, background-image, background-position"
    },
    easing: {
        "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
        "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
        "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    duration: {
        fast: "150ms",
        normal: "200ms",
        slow: "300ms"
    },
    delay: {
        fast: "150ms",
        normal: "200ms",
        slow: "300ms"
    }
};

var modalBox = {
    backgroundColor: colors.backgrounds.onGray,
    borderRadius: radii.x1_5,
    width: sizes$1.x120,
    boxShadow: {
        color: "secondary",
        style: "broad",
        alpha: "x6"
    },
    boxBody: {
        padding: space.x4
    },
    footer: {
        desktopPaddingTop: space.x6,
        padding: space.x4
    },
    headerLabel: {
        padding: space.x4,
        paddingRight: space.x0
    },
    closeButton: {
        margin: space.x4,
        mobileHeight: sizes$1.x12,
        mobileRight: space.x1,
        mobileTop: space.x1,
        mobileMargin: space.x0,
        mobilePadding: space.x4
    },
    border: {
        style: borderStyles.solid,
        width: borderWidths.sm,
        color: colors.borders.default,
        transparentColor: colors.transparent
    },
    transition: {
        timingFunction: transitions.easing["ease-out"],
        property: transitions.property.common,
        duration: transitions.duration.fast
    }
};

var modalUnderlay = {
    backgroundColor: colors.backgrounds.dark,
    opacity: opacity.underlay,
    desktop: {
        paddingTop: space.x18,
        paddingBottom: space.x18,
        padding: space.x6
    },
    tablet: {
        padding: space.x6
    },
    mobile: {
        padding: space.x1
    }
};

var base = {
    itemSeparator: {
        style: "leftInnerBorder",
        color: "white",
        alpha: "x2"
    }
};
var navItem = {
    paddingLeft: space.x3,
    paddingRight: space.x3
};
var topBar = {
    height: sizes$1.x12,
    color: colors.text.onDark,
    backgroundColor: colors.brand.navy
};

var zIndices = {
    hide: "-1",
    auto: "auto",
    base: "0",
    tableColumnHeader: "1",
    pinnedTableRowHeader: "1",
    pinnedTableColumnHeader: "2",
    contentOverlay: "100",
    navOverlay: "200",
    dropdown: "1000",
    overlay: "1300",
    modal: "1400",
    popover: "1500",
    toast: "1700",
    tooltip: "1800"
};

var tab = {
    padding: space.x2,
    tabStates: {
        inactive: {
            color: colors.controls.default
        },
        hovered: {
            color: colors.controls.primary,
            markerColor: colors.controls.secondaryHover
        },
        active: {
            color: colors.controls.primaryActive,
            markerColor: colors.controls.primaryActive
        },
        focussed: {
            color: colors.controls.primary,
            markerColor: colors.controls.secondaryHover
        }
    },
    tabMarker: {
        borderBottom: {
            style: borderStyles.solid,
            width: borderWidths.md,
            color: colors.controls.secondaryHover
        },
        borderRadius: {
            topLeft: radii.x1_5,
            topRight: radii.x1_5,
            bottomRight: radii.x0,
            bottomLeft: radii.x0
        },
        height: "1px",
        width: "100%"
    }
};
var tabList = {
    padding: space.x1,
    borderBottom: {
        style: borderStyles.solid,
        width: borderWidths.sm,
        color: colors.borders.default
    }
};
var tabPanel = {
    background: colors.backgrounds.onGray
};
var moreMenuBox = {
    zIndex: zIndices.dropdown
};
var moreButtonCaret = {
    marginLeft: space.x2
};

var tooltipBase = {
    borderRadius: radii.x1_5,
    backgroundColor: colors.backgrounds.dark,
    boxShadow: {
        alpha: "x3",
        style: "broad",
        color: "secondary"
    },
    paddingTop: space.x1,
    paddingBottom: space.x1,
    paddingLeft: space.x3,
    paddingRight: space.x3,
    maxWidth: sizes$1.x100,
    minWidth: sizes$1.x7
};
var tooltipAnimationsBase = {
    duration: transitions.duration.fast,
    delay: transitions.delay.slow,
    timingFunction: transitions.easing["ease-out"]
};
var tooltipAnimationStates = {
    top: {
        from: {
            opacity: 0,
            marginBottom: sizes$1.x4,
            marginTop: "0"
        },
        to: {
            opacity: 1,
            marginBottom: sizes$1.x2,
            marginTop: "0"
        }
    },
    left: {
        from: {
            opacity: 0,
            marginRight: sizes$1.x4,
            marginLeft: "0"
        },
        to: {
            opacity: 1,
            marginRight: sizes$1.x2,
            marginLeft: "0"
        }
    },
    right: {
        from: {
            opacity: 0,
            marginLeft: sizes$1.x4,
            marginRight: "0"
        },
        to: {
            opacity: 1,
            marginLeft: sizes$1.x2,
            marginRight: "0"
        }
    },
    bottom: {
        from: {
            opacity: 0,
            marginTop: sizes$1.x4,
            marginBottom: "0"
        },
        to: {
            opacity: 1,
            marginTop: sizes$1.x2,
            marginBottom: "0"
        }
    }
};

var expandableRegion = {
    borderRadius: radii.x1_5,
    backgroundColor: colors.backgrounds.onGray,
    marginBottomHeader: space.x4,
    paddingRightLabel: space.x2
};

var container = {
    backgroundColor: colors.backgrounds.default
};
var content = {
    margin: space.x6
};

var body = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container,
  content: content
});

var matchScoreStar = {
    captionColor: colors.text.secondary,
    fillDefaultColor: colors.neutrals["400"],
    fillActiveColor: colors.text.primary
};

var card = {
    borderRadius: radii.x1_5
};

var control = {
    maxWidth: sizes$1.x80
};
var selectedLabel = {
    fontWeight: fontWeights.standard
};
var input = {
    marginBottom: space.x2,
    marginRightLeft: space.x3,
    marginTop: space.x0
};
var item = {
    height: sizes$1.x9
};
var loadingSpinner = {
    paddingBottom: space.x2
};

var select = /*#__PURE__*/Object.freeze({
  __proto__: null,
  control: control,
  selectedLabel: selectedLabel,
  input: input,
  item: item,
  loadingSpinner: loadingSpinner
});

var popover = {
    backgroundColor: colors.backgrounds.onGray,
    borderRadius: radii.x1_5,
    boxShadow: {
        alpha: "x3",
        style: "broad",
        color: "secondary"
    },
    marginTop: space.x1,
    paddingRightLeft: space.x0,
    paddingTopBottom: space.x2,
    zIndex: zIndices.dropdown
};

var itemLabel = {
    fontSize: "s",
    lineHeight: "default"
};
var itemDescription = {
    fontSize: "xs",
    lineHeight: "default",
    color: "secondary"
};

var autocomplete = /*#__PURE__*/Object.freeze({
  __proto__: null,
  itemLabel: itemLabel,
  itemDescription: itemDescription
});

var radioButton = {
    defaultColor: colors.neutrals[700],
    activeColor: colors.indigos[500],
    disabledOpacity: opacity.faded,
    marginRight: space.x2,
    minHeight: sizes$1.x5,
    borderStyle: borderStyles.solid,
    activeBorderWidth: borderWidths.md,
    borderWidth: borderWidths.sm,
    hoverBoxShadow: {
        alpha: "x5",
        style: "medium",
        color: "primary"
    }
};
var radioGroup = {
    errorColor: colors.reds[500],
    descriptionColor: colors.neutrals[700],
    buttonGap: space.x3
};

var baseToggle = {
    marginRight: space.x2,
    gap: space.x1,
    transition: {
        timingFunction: transitions.easing["ease-out"],
        property: transitions.property.common,
        duration: transitions.duration.fast
    },
    defaultState: {
        onColor: colors.controls.primary,
        offColor: colors.borders.form
    }
};
var toggleKnob = {
    padding: space.x_5,
    color: colors.backgrounds.onGray,
    sizeStandard: sizes$1.x5,
    sizeLarge: sizes$1.x7
};
var toggleLabel = paragraphs.compact;
var toggleStates = {
    hover: {
        onColor: colors.controls.primaryHover
    },
    pressed: {
        onColor: colors.controls.primaryActive
    },
    focus: {},
    disabled: {
        opacity: opacity.faded
    },
    loading: {}
};

var chip = {
    common: {
        borderStyle: borderStyles.solid,
        borderWidth: borderWidths.sm,
        skeletonLoadingColor: "secondary",
        closeButton: {
            outlineOffset: outlines.item.offset
        }
    },
    variants: {
        standard: {
            height: sizes$1.x7,
            minWidth: sizes$1.x7,
            maxWidth: sizes$1.x74,
            fontSize: "s",
            lineHeight: "xs",
            iconSize: iconSizes.standard,
            borderRadius: radii.x3_5,
            padding: space.x2,
            paddingRight: space.x7,
            closeButton: {
                width: sizes$1.x7,
                height: sizes$1.x7
            }
        },
        small: {
            height: sizes$1.x6,
            minWidth: sizes$1.x6,
            maxWidth: sizes$1.x56,
            fontSize: "xs",
            lineHeight: "xs",
            iconSize: iconSizes.small,
            borderRadius: radii.x3,
            padding: space.x2,
            paddingRight: space.x6,
            closeButton: {
                width: sizes$1.x6,
                height: sizes$1.x6
            }
        }
    },
    states: {
        default: {
            backgroundColor: colors.backgrounds.onGray,
            borderColor: colors.borders.default,
            color: colors.text.default
        },
        hover: {
            backgroundColor: colors.controls.secondaryHover,
            borderColor: colors.controls.secondaryHover,
            color: colors.text.default
        },
        active: {
            backgroundColor: colors.controls.secondaryActive,
            borderColor: colors.controls.secondaryActive,
            color: colors.text.default
        },
        pressed: {
            backgroundColor: colors.backgrounds.accent,
            borderColor: colors.borders.primary,
            color: colors.text.primary
        },
        disabled: {
            opacity: opacity.faded
        },
        focus: {
            outline: outlines.control,
            outlineNone: outlines.none
        }
    }
};

var styles = {
    buttons: {
        base: buttonBase,
        variant: buttonVariants
    },
    radioGroup: {
        base: radioGroup,
        button: radioButton
    },
    toggle: {
        base: baseToggle,
        knob: toggleKnob,
        label: toggleLabel,
        states: toggleStates
    },
    headings: headings,
    links: {
        base: baseLink,
        variants: linkVariants,
        settings: linkSettings
    },
    paragraphs: paragraphs,
    pills: {
        base: basePill,
        variants: pillVariants,
        typography: pillTypography
    },
    uiText: uiText,
    uiInterspersedText: uiInterspersedText,
    inputs: {
        base: baseInput,
        states: inputStates
    },
    tables: {
        header: header,
        cell: cell,
        row: row,
        subRow: subRow,
        cellSizes: cellSizes,
        rowStates: rowStates,
        subRowStates: subRowStates,
        cellVariants: cellVariants
    },
    notifications: {
        status: notificationStatuses,
        variant: notificationVariants
    },
    emptyState: {
        container: container$1
    },
    icons: {
        sizes: iconSizes,
        strokeWidths: strokeWidths,
        beameryIconSize: beameryIconSize
    },
    checkboxes: {
        base: checkboxBase,
        icon: checkboxIcon,
        states: checkboxIconStates
    },
    listBoxes: {
        base: listBoxBase,
        section: listBoxSection,
        sectionLabel: listBoxSectionLabel,
        emptyState: listBoxEmptyState
    },
    listBoxItems: {
        base: listBoxItemBase,
        states: listBoxItemStates
    },
    lists: {
        base: listBase
    },
    listItems: {
        withSeperator: listItemWithSeperator
    },
    menuBox: menuBox,
    modalBox: modalBox,
    modalUnderlay: modalUnderlay,
    navigation: {
        base: base,
        topBar: topBar,
        navItem: navItem
    },
    body: body,
    tabs: {
        tab: tab,
        tabList: tabList,
        tabPanel: tabPanel,
        moreMenuBox: moreMenuBox,
        moreButtonCaret: moreButtonCaret
    },
    tooltip: {
        base: tooltipBase,
        animations: {
            base: tooltipAnimationsBase,
            states: tooltipAnimationStates
        }
    },
    fieldSet: {
        contentContainer: contentContainer,
        legend: legend
    },
    card: card,
    expandableRegion: expandableRegion,
    matchScoreStar: matchScoreStar,
    select: select,
    popover: popover,
    autocomplete: autocomplete,
    chip: chip
};

var BASE = 4;
var x = function(multiplier) {
    return "".concat((multiplier || 0) * BASE, "px");
};
var sizes = {
    x: x
};
var spaces = {
    x: x
};

var helpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sizes: sizes,
  spaces: spaces
});

var theme = {
    borderStyles: borderStyles,
    borderWidths: borderWidths,
    breakpoints: breakpoints,
    colors: colors,
    debounceTime: debounceTime,
    throttleTime: throttleTime,
    fontSizes: fontSizes,
    fontWeights: fontWeights,
    fonts: fonts,
    letterSpacings: letterSpacings,
    lineHeights: lineHeights,
    mediaQueries: mediaQueries,
    opacity: opacity,
    outlines: outlines,
    radii: radii,
    shadows: shadows,
    sizes: sizes$1,
    space: space,
    styles: styles,
    textDecorationThicknesses: textDecorationThicknesses,
    textDecorationLines: textDecorationLines,
    transitions: transitions,
    zIndices: zIndices,
    helpers: helpers
};

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var mergeObjects = function(base, overrides) {
    return Object.entries(overrides).reduce(function(rv, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (value === undefined) {
            return rv;
        }
        if (value === null || typeof value !== "object" || Array.isArray(value)) {
            return _object_spread_props$1(_object_spread$1({}, rv), _define_property$1({}, key, value));
        }
        return _object_spread_props$1(_object_spread$1({}, rv), _define_property$1({}, key, mergeObjects(rv[key], value)));
    }, base);
};

/* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-nocheck Tech dept DS system has hardcoded colors in types
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var colorToHex = function(color) {
    return color.hex();
};
var mergeTheme = function(overrides) {
    return mergeObjects(theme, overrides);
};
var createLegacyTheme = function(param) {
    var baseColor = param.baseColor;
    var colorForTransforms = Color$1(baseColor);
    if (colorForTransforms.contrast(Color$1("white")) < 4.5) {
        return theme;
    }
    var base = colorToHex(colorForTransforms);
    var variant1 = colorToHex(colorForTransforms.darken(0.1).desaturate(0.1));
    var variant2 = colorToHex(colorForTransforms.darken(0.2).desaturate(0.2));
    var variant3 = colorToHex(colorForTransforms.lightness(96));
    return mergeTheme({
        colors: {
            text: {
                primary: base,
                primaryOnDark: variant3
            },
            borders: {
                primary: base
            },
            controls: {
                primary: base,
                primaryHover: variant1,
                primaryActive: variant2
            }
        },
        styles: {
            links: {
                settings: {
                    standalone: _object_spread_props(_object_spread({}, theme.styles.links.settings.standalone), {
                        ":hover": {
                            color: variant1
                        },
                        ":active": {
                            color: variant1
                        },
                        ":visited": {
                            color: variant1
                        }
                    }),
                    inline: _object_spread_props(_object_spread({}, theme.styles.links.settings.inline), {
                        color: "primary",
                        ":hover": {
                            color: base
                        },
                        ":active": {
                            color: base
                        },
                        ":visited": {
                            color: base
                        }
                    })
                }
            },
            matchScoreStar: {
                fillDefaultColor: variant3,
                fillActiveColor: base
            },
            buttons: {
                variant: {
                    primary: {
                        inactive: {
                            boxShadow: {
                                color: "secondary"
                            }
                        },
                        hovered: {
                            boxShadow: {
                                color: "secondary"
                            }
                        }
                    }
                }
            }
        },
        outlines: {
            input: {
                rule: "".concat(theme.borderWidths.md, " ").concat(theme.borderStyles.solid, " ").concat(base)
            },
            control: {
                rule: "".concat(theme.borderWidths.md, " ").concat(theme.borderStyles.solid, " ").concat(base)
            },
            item: {
                rule: "".concat(theme.borderWidths.md, " ").concat(theme.borderStyles.solid, " ").concat(base)
            },
            link: {
                rule: "".concat(theme.borderWidths.md, " ").concat(theme.borderStyles.solid, " ").concat(base)
            },
            tab: {
                rule: "".concat(theme.borderWidths.md, " ").concat(theme.borderStyles.solid, " ").concat(base)
            }
        }
    });
};
var colorContrastCheck = function(color) {
    return Color$1(color).contrast(Color$1("white")) > 4.5;
};
var getThemeColors = function(baseColor) {
    var baseColorForTransforms = Color$1(baseColor);
    var defaultGray = Color$1("#1F1F23");
    return {
        baseColor: {
            base: colorToHex(baseColorForTransforms),
            useLightTextOnBase: colorContrastCheck(baseColor),
            variant1: colorToHex(baseColorForTransforms.darken(0.1).desaturate(0.1)),
            variant2: colorToHex(baseColorForTransforms.darken(0.2).desaturate(0.2)),
            variant3: colorToHex(baseColorForTransforms.lightness(96))
        },
        defaultGray: {
            base: colorToHex(defaultGray),
            variant1: colorToHex(defaultGray.darken(0.1).desaturate(0.1)),
            variant2: colorToHex(defaultGray.darken(0.2).desaturate(0.1))
        }
    };
};
var createNewTheme = function(param) {
    var baseColor = param.baseColor;
    var _getThemeColors = getThemeColors(baseColor), _getThemeColors_baseColor = _getThemeColors.baseColor, base = _getThemeColors_baseColor.base, useLightTextOnBase = _getThemeColors_baseColor.useLightTextOnBase, variant1 = _getThemeColors_baseColor.variant1, variant2 = _getThemeColors_baseColor.variant2, variant3 = _getThemeColors_baseColor.variant3, _getThemeColors_defaultGray = _getThemeColors.defaultGray, defaultGrayBase = _getThemeColors_defaultGray.base, defaultGrayVariant1 = _getThemeColors_defaultGray.variant1, defaultGrayVariant2 = _getThemeColors_defaultGray.variant2;
    return mergeTheme({
        colors: {
            text: {
                primary: useLightTextOnBase ? base : defaultGrayBase,
                primaryOnDark: variant3
            },
            borders: {
                primary: useLightTextOnBase ? base : defaultGrayBase,
                primaryActive: useLightTextOnBase ? base : defaultGrayBase
            },
            controls: {
                primary: base,
                primaryHover: variant1,
                primaryActive: variant2
            },
            shadows: {
                primary: base,
                secondary: variant1
            }
        },
        styles: {
            checkboxes: {
                states: {
                    hover: {
                        borderColor: useLightTextOnBase ? base : defaultGrayVariant1
                    },
                    active: {
                        borderColor: useLightTextOnBase ? base : defaultGrayVariant1,
                        backgroundColor: useLightTextOnBase ? "primary" : "default"
                    }
                }
            },
            radioGroup: {
                button: {
                    activeColor: useLightTextOnBase ? base : defaultGrayVariant1
                }
            },
            links: {
                settings: {
                    standalone: _object_spread_props(_object_spread({}, theme.styles.links.settings.standalone), {
                        ":hover": {
                            color: useLightTextOnBase ? variant1 : defaultGrayVariant1
                        },
                        ":active": {
                            color: useLightTextOnBase ? variant1 : defaultGrayVariant1
                        },
                        ":visited": {
                            color: useLightTextOnBase ? variant1 : defaultGrayVariant2
                        }
                    }),
                    inline: _object_spread_props(_object_spread({}, theme.styles.links.settings.inline), {
                        color: "primary",
                        ":hover": {
                            color: useLightTextOnBase ? base : defaultGrayBase
                        },
                        ":active": {
                            color: useLightTextOnBase ? base : defaultGrayBase
                        },
                        ":visited": {
                            color: useLightTextOnBase ? base : defaultGrayBase
                        }
                    })
                }
            },
            matchScoreStar: {
                fillDefaultColor: variant3,
                fillActiveColor: base
            },
            buttons: {
                variant: {
                    primary: {
                        active: {
                            textColor: useLightTextOnBase ? "onDark" : "#000000",
                            boxShadow: {
                                color: "primary"
                            }
                        },
                        focused: {
                            textColor: useLightTextOnBase ? "onDark" : "#000000",
                            boxShadow: {
                                color: "primary"
                            }
                        },
                        inactive: {
                            textColor: useLightTextOnBase ? "onDark" : "#000000",
                            boxShadow: {
                                color: "primary"
                            }
                        },
                        hovered: {
                            textColor: useLightTextOnBase ? "onDark" : "#000000",
                            boxShadow: {
                                color: "primary"
                            }
                        }
                    }
                }
            }
        },
        outlines: {
            input: {
                rule: "".concat(theme.borderWidths.md, " ").concat(theme.borderStyles.solid, " ").concat(useLightTextOnBase ? base : defaultGrayBase)
            },
            control: {
                rule: "".concat(theme.borderWidths.md, " ").concat(theme.borderStyles.solid, " ").concat(useLightTextOnBase ? base : defaultGrayBase)
            },
            item: {
                rule: "".concat(theme.borderWidths.md, " ").concat(theme.borderStyles.solid, " ").concat(useLightTextOnBase ? base : defaultGrayBase)
            },
            link: {
                rule: "".concat(theme.borderWidths.md, " ").concat(theme.borderStyles.solid, " ").concat(useLightTextOnBase ? base : defaultGrayBase)
            },
            tab: {
                rule: "".concat(theme.borderWidths.md, " ").concat(theme.borderStyles.solid, " ").concat(useLightTextOnBase ? base : defaultGrayBase)
            }
        }
    });
};
var createTheme = function(options) {
    var _options_enableAccessibleTheming = options.enableAccessibleTheming, enableAccessibleTheming = _options_enableAccessibleTheming === void 0 ? true : _options_enableAccessibleTheming;
    if (enableAccessibleTheming) {
        return createNewTheme(options);
    }
    return createLegacyTheme(options);
};

export { BREAKPOINTS, MEDIA_QUERIES, colorContrastCheck, createTheme };
